export default "__VITE_ASSET__C$K2Rr4D__$_?url__"